export default __webpack_public_path__ + "static/media/Perrito1.05615700.png";